export default "__VITE_ASSET__d8de205f__"